import { ILastActionState } from "../store/state";

export const lastAction = (state:ILastActionState = null, action:any) : ILastActionState => {
  return action
}

export default lastAction
